export default "__VITE_ASSET__3CezgrBp__"